import React, { useState } from 'react';
import { supabase } from './supabaseClient';

function Auth() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');

 const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase.auth.signInWithOtp({ 
      email,
      options: {
        // Pointing directly to your custom domain Matrix
        emailRedirectTo: 'https://www.adonisian.com', 
      }
    });
    
    if (error) {
      alert(error.error_description || error.message);
    } else {
      alert('Check your email for the Adonisian login link!');
    }
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <h2 style={{ color: '#ffca28', letterSpacing: '1px', textTransform: 'uppercase' }}>Continue Your Ascendance</h2>
      <p style={{ color: '#8b949e', fontStyle: 'italic', marginBottom: '15px' }}>"Welcome back to source code. Your cosmic link out of the matrix awaits."</p>
      <p style={{ color: '#c9d1d9', fontSize: '0.9rem' }}>Enter your email to access your 13 Keys and track your Guru progress.</p>
      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={{ padding: '10px', borderRadius: '4px', width: '80%', border: '1px solid #30363d', background: '#05070a', color: 'white' }}
        />
        <br />
        <button disabled={loading} style={{ marginTop: '15px', padding: '10px 20px', cursor: 'pointer', backgroundColor: '#ffca28', color: '#0d1117', fontWeight: 'bold', border: 'none', borderRadius: '4px' }}>
          {loading ? 'Initializing...' : 'Send Magic Link'}
        </button>
      </form>
    </div>
  );
}

export default Auth;